import { useEffect, useState } from 'react';
import { WEBSITE_LANDING_COUNTRY_KEY, WEBSITE_LANDING_LANGUAGE_KEY } from '@/website/constants/local-storage';
import { useLocaleContext } from '@/website/contexts/AppContext';
import {
  getAllSupportDisplayCountryListWithAllCountries,
  getAllWebsiteAvailableLanguages,
  getMainLanguageByCountryCode,
  useCountryStore,
} from '@jove-frontend/uikit';

export const useInternationalizationLanguage = (initialData: { country: string; language: string }) => {
  const {
    state: { countries },
  } = useCountryStore();
  const [selectCountry, setSelectCountry] = useState(initialData?.country);
  const [canSelectCountryList, setCanSelectCountryList] = useState([]);
  const [selectLanguage, setSelectLanguage] = useState(initialData?.language);
  const [canSelectLanguageList, setCanSelectLanguageList] = useState([]);
  const { setGlobalCountry, setLanguage } = useLocaleContext();

  /**
   * effects
   */
  useEffect(() => {
    setCanSelectCountryList(getAllSupportDisplayCountryListWithAllCountries(countries));
  }, [countries]);

  useEffect(() => {
    setCanSelectLanguageList(getAllWebsiteAvailableLanguages());
  }, []);

  /**
   * methods
   */
  const selectCountryChangeAction = (value) => {
    const countryLanguage = getMainLanguageByCountryCode(value);
    localStorage.setItem(WEBSITE_LANDING_COUNTRY_KEY, value);
    localStorage.setItem(WEBSITE_LANDING_LANGUAGE_KEY, countryLanguage);
    setSelectCountry(value);
    setGlobalCountry(value);
    setSelectLanguage(countryLanguage);
    setLanguage(countryLanguage as any);
    const url = new URL(window.location.href);
    const segments = url.pathname.split('/').filter(Boolean);
    const localeSegments = new Set(getAllWebsiteAvailableLanguages().map((item) => item.value.toLowerCase()));
    const restSegments = localeSegments.has(segments[0]?.toLowerCase()) ? segments.slice(1) : segments;
    const nextLocale = countryLanguage.toLowerCase();
    url.pathname =
      nextLocale === 'en' ? `/${restSegments.join('/')}` || '/' : `/${nextLocale}${restSegments.length ? `/${restSegments.join('/')}` : ''}`;
    url.searchParams.set('country', value.toUpperCase());
    window.location.href = url.toString();
  };

  const selectLanguageChangeAction = (value) => {
    localStorage.setItem(WEBSITE_LANDING_LANGUAGE_KEY, value);
    setSelectLanguage(value);
    setLanguage(value);
    const url = new URL(window.location.href);
    const segments = url.pathname.split('/').filter(Boolean);
    const localeSegments = new Set(getAllWebsiteAvailableLanguages().map((item) => item.value.toLowerCase()));
    const restSegments = localeSegments.has(segments[0]?.toLowerCase()) ? segments.slice(1) : segments;
    const nextLocale = value.toLowerCase();
    url.pathname =
      nextLocale === 'en' ? `/${restSegments.join('/')}` || '/' : `/${nextLocale}${restSegments.length ? `/${restSegments.join('/')}` : ''}`;
    window.location.href = url.toString();
  };

  return {
    selectCountry,
    setSelectCountry,
    canSelectCountryList,
    selectLanguage,
    setSelectLanguage,
    canSelectLanguageList,
    selectCountryChangeAction,
    selectLanguageChangeAction,
  };
};
